import React from "react";
import "./App.css";

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <p className="App-header-text">I'm a teapot. (418)</p>
        <p>@federzvz</p>
      </header>
    </div>
  );
}

export default App;
